import React from 'react'

import UISelect from 'components/shared/UISelect'

import BotFollowUp from '../botFollowUp'
import style from '../style.styl'

const MatchAnswerBody = ({
  skipToOptions,
  currentSkipToOption,
  onSkipToChange,
  targetCopy,
  shortTargetCopy,
  botFollowUpProps,
}) => {
  return (
    <div className={style.AnswerModalContent}>
      <BotFollowUp {...botFollowUpProps} />
      <div className="drift-form">
        <strong>Trigger On Successful Capture</strong>
        <p>
          When a user responds with a valid {targetCopy}, we’ll trigger this follow up and add this{' '}
          {shortTargetCopy} to their contact record. If we already know their {shortTargetCopy},
          we’ll automatically skip to the Next Step!
          {/*<a target="_blank" href="https://help.drift.com/campaigns/replies">
            Learn More
          </a>*/}
        </p>
      </div>
      <div className="drift-form">
        <strong>Next Step</strong>
        <p>
          If user matches this follow up, end the conversation or skip them to a different question
          or goal. You can only skip ahead.
        </p>
        <UISelect
          className="skip-select"
          options={skipToOptions}
          clearable
          value={currentSkipToOption}
          onChange={onSkipToChange}
        />
      </div>
    </div>
  )
}

export default MatchAnswerBody



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/AnswerModal/AnswerModalMatchBody/component.js